import { reducerType } from '../../reducers/searchBookings';

export function setSearchBookings(values) {
  return {
    type: `${reducerType}/SET_SEARCH_VALUES`,
    payload: values || {}
  };
}

export function clearSearchBookings() {
  return {
    type: `${reducerType}/CLEAR`
  };
}
